module.exports = __webpack_public_path__ + "img/a49f455.png";